import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 1. Vue-Meta@Next
// npm install vue-meta@3.0.0-alpha.10
// here config use "meta", App/js need to use "meta" as the key name
import { createMetaManager, plugin as vueMetaPlugin} from 'vue-meta'
const metaManager = createMetaManager(
    false, {
        meta: { tag: 'meta', nameless: true }
    }
)

// 2. Import Bootstrap CSS + JS
// npm install bootstrap
// npm install bootstrap-icons
// Below is for fix on boostrap 5
// npm install autoprefixer@10.4.5 --save-exact
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap-icons/font/bootstrap-icons.css'

// 3. Import VueSweetalert2 (Pop Up Menu)
// npm install -S vue-sweetalert2
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

// 4. Import Vue-Final-Model (Custom Pop Up Menu)
// npm install vue-final-modal@next
import vfmPlugin from 'vue-final-modal'

// 5. Vue Toaster
// npm install @meforma/vue-toaster
import Toaster from "@meforma/vue-toaster";

// 6. Import multiSelect
// npm install @vueform/multiselect

// 7. Import Tabulator
// npm install tabulator-tables


//8. Import Vue Light Box (Image Reader)
// npm install --save vue-easy-lightbox@next

// 9. i18n for vue
// npm install vue-i18n@9
import en from './locales/en.json'
import zh from './locales/zh-hk.json'
import { createI18n } from 'vue-i18n'
const i18n = createI18n({
    locale: 'en',
    fallbackLocale:  'en',
    messages: loadLocaleMessages()
})

function loadLocaleMessages() {
    const locales = [{ en: en }, { zh: zh }]
    const messages = {}
    locales.forEach(lang => {
        const key = Object.keys(lang)
        messages[key] = lang[key]
    })
    return messages
}

//10. ChartJS install
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement,
    LineElement, PointElement, CategoryScale, LinearScale, ArcElement } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement, ArcElement)

// <<<< DEBUG USE >>>>>
// npm install eruda
import eruda from "eruda";
eruda.init()

// <<<<<<<<<<<<  Global Functions >>>>>>>>>>>>>
import http from "@/tools/MainApi.vue"
import serverErrorReturn from "@/tools/SerializerErrorsToHTML.vue"
import getHeaderMenu from "@/tools/GetHeaderMenu.vue"
import authSetup from "@/tools/AuthSetup.vue"
import permission from "@/tools/PermissionChecker.vue"

// ---------- FINAL ------------
const app = createApp(App)

app.use(store)
    .use(router)
    // 1. Vue-Meta@Next
    .use(metaManager)
    // 9. i18n for vue
    .use(i18n)
    // 3. Import VueSweetalert2 (Pop Up Menu)
    .use(VueSweetalert2)
    // 4. Import Vue-Final-Model (Custom Pop Up Menu)
    .use(vfmPlugin)
    // 5. Vue Toaster
    .use(Toaster)

// Global Variables
app.config.globalProperties.$getDemoMode = "false";

// app.config.globalProperties.$checker = mainApi
app.config.globalProperties.$mainApi = http
app.config.globalProperties.$serverErrorReturn = serverErrorReturn
app.config.globalProperties.$getHeaderMenu = getHeaderMenu
app.config.globalProperties.$authSetup = authSetup
app.config.globalProperties.$permissionCheck = permission
window.Swal =  app.config.globalProperties.$swal

// Put Mount at the end as those Global variables aren't set up
app.mount('#app')
